export enum ETextImprove {
    SIMPLIFY = 'simplify',
    ADD_CREATIVITY = 'addCreativity',
    MAKE_SHORTER = 'makeShorter',
    MAKE_LONGER = 'makeLonger',
    CORRECT_MISTAKES = 'correctMistakes',
}
